<template>
  <div>
    <label v-if="label" class="pl-2 label-text">{{ label }}</label>
    <v-menu
      ref="menu"
      v-model="menu"
      :close-on-content-click="false"
      :return-value.sync="date"
      transition="scale-transition"
      offset-y
      min-width="auto"
      class="mt-0 pt-0"
    >
      <template #activator="{ on, attrs }">
        <v-text-field
          v-model="dateFormatted"
          v-mask="'##.##.####'"
          :disabled="disabled"
          class="mt-1 rounded-lg py-0 mini-text field-edit"
          outlined dense
          :class="errorMessages && errorMessages.length ? 'field-error' : ''"
          :placeholder="placeholder"
          :clearable="clearable"
          :hide-details="hideDetails"
          :height="20"
          :hint="hint"
          :persistent-hint="persistentHint"
          v-bind="attrs"
          :error-messages="errorMessages"
          v-on="on"
          @change="setDate"
          @click:clear="clear"
          @blur="$emit('blur')"
        />
      </template>
      <v-date-picker
        v-model="date"
        locale="ru-RU"
        color="green primary"
        format="DD.MM.YYYY"
        first-day-of-week="1"
        no-title
        scrollable @input="save(date)"
      />
    </v-menu>
  </div>
</template>

<script>
import { dateFormat } from '@/scripts/validation'

export default {
  name: 'UIDatePickerMenu',

  components: {},

  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    hideDetails: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    value: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: 'Выберите значение',
    },
    errorMessages: {
      type: Array,
      default: null,
    },
    hint: {
      type: String,
      default: '',
    },
    persistentHint: {
      type: Boolean,
      default: true,
    },
  },

  mounted() {
    if (!this.date) this.date = this.value
  },

  data: () => ({
    menu: false,
    date: null,
    dateFormatted: null,
    clicks: 0,
    timer: null,
    delay: 200,
  }),

  methods: {
    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}.${month}.${year}`
    },

    clear() {
      this.date = null
      this.save(null)
    },

    save(date) {
      this.$refs.menu.save(date)
      this.$emit('input', date)
      this.$emit('change', date)
    },

    setDate(newDate) {
      const date = newDate ? newDate.split('.').reverse().join('-') : ''
      if (dateFormat(date)) {
        this.$refs.menu.save(date)
        this.$emit('input', date)
        this.$emit('change', date)
      } else {
        this.dateFormatted = this.formatDate(this.value)
        this.setDate(this.dateFormatted)
      }
    },
  },

  watch: {
    value(v) {
      this.date = v
    },

    date(v) {
      this.dateFormatted = this.formatDate(v)
    },
  },
}
</script>
